import InstalacaoOpcao from "@/views/Instalacao/Opcoes.vue";
import InstalacaoPassoAPasso from "@/views/Instalacao/PassoAPasso.vue";
import InstalacaoPassoAPassoA3Presencial from "@/views/Instalacao/PassoAPassoA3Presencial.vue";

export default [
	{
		path: "/suporte/instalacao/a3-token-ou-cartao",
		name: "a3-token-ou-cartao",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			name: "a3-token-ou-cartao",
			title: "A3 Token ou Cartão",
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A3 Token ou Cartão",
					href: "/suporte/instalacao/a3-token-ou-cartao",
				},
			],
			description:
				"Para instalação do seu certificado é necessário Windows 10 ou superior. Selecione abaixo a forma de emissão do seu Certificado Digital SPC Brasil.",
			cards: [
				{
					icon: "/certificacaodigital/images/instalacao/presencial.svg",
					title: "Presencial",
					content: "Instale o Certificado Digital SPC Brasil que foi emitido presencialmente.",
					href: "a3-token-ou-cartao/presencial",
				},
				{
					icon: "/certificacaodigital/images/instalacao/video_conferencia.svg",
					title: "Videoconferência",
					content: "Instale o Certificado Digital SPC Brasil que foi solicitado através da videoconferência.",
					href: "a3-token-ou-cartao/videoconferencia",
				},
				{
					icon: "/certificacaodigital/images/instalacao/wifi.svg",
					title: "Online",
					content: "Instale o Certificado Digital SPC Brasil de forma autônoma, através do seu e-CPF A3 válido.",
					href: "a3-token-ou-cartao/online",
				},
				{
					icon: "/certificacaodigital/images/instalacao/renovacao.svg",
					title: "Renovação",
					content: "Conclua a renovação a partir do Certificado Digital SPC Brasil A3 válido.",
					href: "a3-token-ou-cartao/renovacao",
				},
			],
		},
		component: InstalacaoOpcao,
	},
	{
		path: "/suporte/instalacao/a3-token-ou-cartao/presencial",
		name: "a3-token-ou-cartao-presencial",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			name: "a3-token-ou-cartao-presencial",
			linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_online.pdf",
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A3 Token ou Cartão",
					href: "/suporte/instalacao/a3-token-ou-cartao",
				},
				{
					label: "emissão presencial",
					href: "/suporte/instalacao/a3-token-ou-cartao/presencial",
				},
			],
			title: "A3 Token ou Cartão",
			subtitle: "Emissão Presencial",
			description:
				"Para instalação do seu certificado é necessário Windows 10 ou superior, abaixo está disponível o download do driver e o manual de instruções sobre seu Certificado Digital SPC Brasil.",
			warning: "Os drivers não são compatíveis com sistema operacional Linux. Para instalação no sistema operacional macOS, recomendamos instalação para versão Catalina ou superior.",
		},
		component: InstalacaoPassoAPassoA3Presencial,
	},
	{
		path: "/suporte/instalacao/a3-token-ou-cartao/videoconferencia",
		name: "a3-token-ou-cartao-videoconferencia",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			name: "a3-token-ou-cartao-videoconferencia",
			linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_videoconferencia.pdf",
			vimeoId: 1038600825,
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A3 Token ou Cartão",
					href: "/suporte/instalacao/a3-token-ou-cartao",
				},
				{
					label: "videoconferência",
					href: "/suporte/instalacao/a3-token-ou-cartao/videoconferencia",
				},
			],
			title: "A3 Token ou Cartão",
			subtitle: "Videoconferência​",
			description:
				"Para instalação do seu certificado é necessário Windows 10 ou superior, abaixo está disponível o download do driver e o manual de instruções sobre seu Certificado Digital SPC Brasil.",
			warning: "O assistente de instalação não é compatível com outros sistemas operacionais (macOS e Linux). Após a finalização da emissão do seu certificado poderá ser feito o uso no seu macOS",
			cards: [
				{
					content: "Conecte a mídia (token/cartão) no computador.<br><strong>Importante:</strong> O certificado (token/cartão) deve estar corretamente instalado e funcionando para a instalação.",
				},
				{
					content: "<b>Clique em download</b>, instale o assistente de instalação, abra e clique em Instalar Certificado.",
					button: {
						href: "https://instalacaocertificado-accndl.safewebpss.com.br/",
						icon: "/certificacaodigital/images/instalacao/download.svg",
						target: "_blank",
						label: "Download",
					},
				},
				{
					content: "Insira o número do protocolo e o número do CPF. Em seguida, clique no botão “Acessar”. Lembre-se que esse processo deve ser feito pelo titular do Certificado Digital;",
				},
				{
					content: "Você receberá um código de confirmação no e-mail cadastrado durante a solicitação do seu Certificado. Digite o código de 6 dígitos e clique em “Verificar”;</br></br><b>Atenção:</b> Caso não localize o e-mail, verifique na pasta de spam, lixo eletrônico ou clique na opção Reenviar Código. Em caso de erros, acione o time de SAC CD.",
				},
				{
					content: "<strong>Digite a senha de Instalação/ Revogação</strong> gerada no momento da sua solicitação e clique em Acessar. Em seguida, assine o termo de titularidade e responsabilidade.",
				},
				{
					content: "Selecione a mídia e em seguida, clique em Emitir Certificado.<br><br><strong>Atenção:</strong> Não retire a mídia até que o processo seja concluído corretamente.",
				},
				{
					content: "Após conclusão do carregamento, <strong>digite a senha PIN do seu dispositivo</strong> e <strong>clique em “Ok”</strong>.",
				},
				{
					content: "<b>Pronto!</b> Após finalizar a emissão reinicie o seu computador. O seu certificado está instalado e pronto para uso.",
				},
			],
		},
		component: InstalacaoPassoAPasso,
	},
	{
		path: "/suporte/instalacao/a3-token-ou-cartao/online",
		name: "a3-token-ou-cartao-online",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			name: "a3-token-ou-cartao-online",
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A3 Token ou Cartão",
					href: "/suporte/instalacao/a3-token-ou-cartao",
				},
				{
					label: "online",
					href: "/suporte/instalacao/a3-token-ou-cartao/online",
				},
			],
			vimeoId: 1038600145,
			title: "A3 Token ou Cartão",
			subtitle: "Online",
			linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_online.pdf",
			description:
				"Para finalização da emissão do seu certificado é necessário Windows 10 ou superior, abaixo está disponível o assistente de instalação e o manual de instruções.",
			warning: "O assistente de instalação não é compatível com outros sistemas operacionais (macOS e Linux). Após a finalização da emissão do seu certificado poderá ser feito o uso no seu macOS.",
			cards: [
				{
					content: "Conecte a mídia (token/cartão) no computador.",
				},
				{
					content: "<strong>Clique em download</strong>, instale o <strong>Assistente Certificado Digital</strong>, abra e clique em <strong>Instalar</strong>. Após carregamento, clique em <strong>Instalar Certificado</strong>.",
					button: {
						href: "https://ferramentas.spc.org.br/InstaladorA1/AssistenteCertificadoDigital.application",
						icon: "/certificacaodigital/images/instalacao/download.svg",
						label: "Download",
					},
				},
				{
					content: "Digite o <strong>protocolo, o CPF e a senha de instalação</strong>. Em seguida, selecione a mídia e clique em Emitir.",
				},
				{
					content: "<strong>Cadastre a sua senha</strong> de revogação e assine o termo de titularidade e responsabilidade.",
				},
				{
					content: "<strong>Confirme a senha PIN</strong> da sua mídia para finalizar a emissão. Após a finalização reinicie o seu computador.<br><br>Pronto! O seu certificado está pronto para uso.",
				},
			],
		},
		component: InstalacaoPassoAPasso,
	},
	{
		path: "/suporte/instalacao/a3-token-ou-cartao/renovacao",
		name: "a3-token-ou-cartao-renovacao",
		meta: {
			canonical: "https://www.spcbrasil.com.br/certificacaodigital/suporte/instalacao",
		},
		props: {
			name: "a3-token-ou-cartao-renovacao",
			breadclumb: [
				{
					label: "suporte",
					href: "/suporte",
				},
				{
					label: "instalação",
					href: "/suporte/instalacao",
				},
				{
					label: "A3 Token ou Cartão",
					href: "/suporte/instalacao/a3-token-ou-cartao",
				},
				{
					label: "renovação",
					href: "/suporte/instalacao/a3-token-ou-cartao/renovacao",
				},
			],
			vimeoId: 1038600723,
			title: "A3 Token ou Cartão",
			subtitle: "Renovação",
			description:
				"Para instalação do seu certificado é necessário Windows 10 ou superior, abaixo está disponível o download do assistente de instalação e o manual de instruções.",
			warning: "O assistente de instalação não é compatível com outros sistemas operacionais (macOS e Linux). Após a finalização da emissão do seu certificado poderá ser feito o uso no seu macOS.",
			linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_renovacao.pdf",
			cards: [
				{
					content: "Conecte a mídia (token/cartão) no computador.",
				},
				{
					content: "<strong>Clique em download</strong>, instale o <strong>Assistente Certificado Digital</strong>, abra e clique em <strong>Instalar</strong>. Após carregamento, clique em <strong>Instalar Certificado</strong>.",
					button: {
						href: "https://ferramentas.spc.org.br/InstaladorA1/AssistenteCertificadoDigital.application",
						icon: "/certificacaodigital/images/instalacao/download.svg",
						label: "Download",
					},
				},
				{
					content: "Digite o protocolo e o CPF. Em seguida, selecione o certificado a ser renovado e clique em Renovar.",
				},
				{
					content: "Confira os dados da sua emissão, clique em Assinar e, em seguida, digite a senha PIN.",
				},
				{
					content: "Cadastre a sua senha de revogação e assine o termo de titularidade e responsabilidade.",
				},
				{
					content: "A senha PIN será solicitada até a finalização da renovação.",
				},
				{
					content: "<strong>Pronto!</strong> O período de validade do seu novo certificado começa automaticamente após o vencimento do certificado atual.",
				},
			],
		},
		component: InstalacaoPassoAPasso,
	},
];
